export default __webpack_public_path__ + "static/product1-b808549b89b118bbef6fd267183d24e2.png";